import common from './common';
import actionTypes from './action-types';
import siteSetupNames from './site-setup-names';
import siteSetupStepsMap from './site-setup-steps-map';
import archetypesMap from './archetypes-map';
import validationPatterns from './validation-patterns';
import triggerIds from './trigger-ids';

export default {
  common,
  actionTypes,
  siteSetupNames,
  siteSetupStepsMap,
  archetypesMap,
  validationPatterns,
  triggerIds,
};
